import React, { Component } from 'react';
import { Modal, Row, Col, Spin, Form, Select, Input, TimePicker, Table, Tooltip, Button } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { createHideTaskNoteModel, asyncTaskNoteUpdate, asynctaskNoteAdd } from './actions';
import Diff from './diff';
import moment from 'moment';
import { stringToTime } from '../../../utils';
import data from './data';
moment.locale('zh-cn');
const FormItem = Form.Item;
const { TextArea } = Input;
const formItemLayout = {
    labelCol: { span: 4, offset: 2 },
    wrapperCol: { span: 16 },
};
class PvcRatio extends React.Component {
    selectChange(index, flag, value1, dateString) {
        dateString = dateString.target.value;
        const { value, onChange } = this.props;

        //通知父组件更新
        //封装数据传参
        let changeVal;
        if (index >= value.length) {
            if (flag == 1) {
                //arr.put({ beginTime: dateString.replace(':', '') });
                arr.put({ pvc: dateString });
            } else {
                //arr.put({ endTime: dateString.replace(':', '') });
                arr.put({ ratio: dateString });
            }
            changeVal = arr;
        } else {
            if (flag == 1) {
                value[index].pvc = dateString;
            } else {
                value[index].ratio = dateString;
            }
            changeVal = value;
        }
        onChange(changeVal);
    }
    addPV = () => {
        
        const { value , onChange } = this.props;
        //value.push({ pvc: 0, ratio: 0 });
        value.push({ pvc: null, ratio: null });
        onChange(value);
    };
    delPV = index => {
        const { value, onChange } = this.props;
        value.splice(index, 1);
        console.log('减少频次占比value',value);

        onChange(value);
    };
    render() {
        const { value } = this.props;

        const inputPile = []; //定义一个数组
        for (let i = 0; i < value.length; i++) {
            // for循环数组
            let index = i;
            inputPile.push(
                //将组件塞入定义的数组中
                <Row>
                    <div>
                    <Col span={18}>

                        <Input style={{width:'50%'}} placeholder="频次" value={value[index].pvc == undefined ? "" : value[index].pvc}
                        onChange={(inputValue) => this.selectChange(index, 1, value, inputValue)}
                        />

                       <Input style={{width:'50%'}} placeholder="占比" value={value[index].ratio == undefined ? "" : value[index].ratio}
                        onChange={(inputValue) => this.selectChange(index, 2, value, inputValue)}
                        />
                    </Col>
                    </div>
                    {i == 0 ? (
                        <Col span={2} style={{ marginLeft: '5px' }}>
                            <Tooltip placement="top" title="添加">
                                <Button
                                    shape="circle"
                                    icon="plus"
                                    size="small"
                                    type="primary"
                                    onClick={() => {
                                        this.addPV();
                                    }}
                                />
                            </Tooltip>
                        </Col>
                    ) : (
                        <Col span={2} style={{ marginLeft: '5px' }}>
                            <Tooltip placement="top" title="删除时间段">
                                <Button
                                    shape="circle"
                                    icon="minus"
                                    size="small"
                                    type="danger"
                                    onClick={() => {
                                        this.delPV(i);
                                    }}
                                />
                            </Tooltip>
                        </Col>
                    )}
                </Row>,
            );
        }
        return <div>{inputPile}</div>;
    }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Form.create()(PvcRatio));



// WEBPACK FOOTER //
// ./pages/task/tasklist/PvcRatio.js